import { Car, Smartphone, UserRound, Package, Radio } from 'lucide-react';
import { resolveMarkerConfig, getIconDef } from '@/lib/markerIcons';

const CATEGORY_ICONS = { phone: Smartphone, person: UserRound, tracker: Radio, asset: Package };

/**
 * Renders the device's chosen marker icon as an inline SVG.
 * Falls back to a Lucide category icon if no custom marker icon is set.
 */
export default function DeviceMarkerIcon({ device, size = 18, color = 'currentColor', className = '' }) {
  const { icon } = resolveMarkerConfig(device?.attributes);
  const def = icon && icon !== 'custom' ? getIconDef(icon) : null;

  if (def) {
    return (
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
      >
        {def.paths.map((d, i) => <path key={i} d={d} />)}
        {def.circles.map((c, i) => <circle key={i} cx={c.cx} cy={c.cy} r={c.r} />)}
      </svg>
    );
  }

  // Fallback: Lucide icon based on device category
  const LucideIcon = CATEGORY_ICONS[device?.category] || Car;
  return <LucideIcon size={size} style={{ color }} className={className} />;
}
